import { render, staticRenderFns } from "./ReportSaberPRO2023.vue?vue&type=template&id=59702370"
import script from "./ReportSaberPRO2023.vue?vue&type=script&lang=js"
export * from "./ReportSaberPRO2023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports